import React from 'react';
import type { HeaderGroup } from 'react-table';
const Footer = ({ footerGroups }: { footerGroups: HeaderGroup<Record<string, unknown>>[] }): JSX.Element => (
  <React.Fragment>
    {footerGroups.map((group) => (
      <tr {...group.getFooterGroupProps()}>
        {group.headers.map((column) => (
          <td
            {...column.getFooterProps()}
            data-id={`footer_${column.id}`}
          >
            {column.render('Footer')}
          </td>
        ))}
      </tr>
    ))}
  </React.Fragment>);

Footer.displayName = 'Footer';

export default Footer;
